<template>
  <div ref="fristhome">
    <el-card class="box-card">
      <!-- <el-form
        label-width="120px"
        :inline="true"
        size="mini"
        :model="addForm"
        ref="addForm"
        :rules="rules"
      >-->
      <el-row :gutter="24">
        <el-col :span="24" >
          <div class="table_box" >
            <el-table
              :data="list"
              v-horizontal-scroll="'always'"
              border
              size="mini"
              style="width: 100%;"
              stripe
              height="auto"
            >
              <el-table-column prop="product_id" width="130px" label="车牌号" align="center">
                <template slot-scope="scope">
                  <!-- <span>{{scope.row.car_id}}</span> -->
                  <el-select v-model="scope.row.car_id" size="mini" filterable clearable placeholder="请选择">
                    <el-option
                      v-for="item in carList"
                      :key="item.id"
                      :label="item.plate_number"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="product_id" width="130px" label="保险产品名称" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">{{scope.row.product_id}}</span> -->
                  <el-select
                    v-model="scope.row.product_id"
                    size="mini"
                    clearable
                    placeholder="请选择产品"
                  >
                    <el-option
                      v-for="item in pList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="200px" label="保司" align="center">
                <template slot-scope="scope">
                  <!--@change="(query)=>{getline(query,scope.$index)}"-->
                  <el-select
                    v-model="scope.row.corp_id"
                    filterable
                    default-first-option
                    size="mini"
                    placeholder="请输入保司"
                    clearable
                  >
                    <el-option
                      v-for="item in corpList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="保费" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">{{scope.row.real_price}}</span> -->
                  <el-input size="mini" v-model="scope.row.real_price"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="净费" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.price"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200" label="保险起期" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">{{scope.row.start_time}}</span> -->
                  <el-date-picker
                    @change="startDateChange($event,scope.$index)"
                    size="mini"
                    style="width: 150px;"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="scope.row.start_time"
                    type="datetime"
                    placeholder="选择投保日期"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column width="220" label="保险止期" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">{{scope.row.end_time}}</span> -->
                  <el-date-picker
                    size="mini"
                    style="width: 180px;"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="scope.row.end_time"
                    type="datetime"
                    placeholder="选择投保日期"
                  ></el-date-picker>
                </template>
              </el-table-column>

              <!-- <el-table-column width="100px" label="保费" align="center">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.real_price}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.real_price"></el-input>
                  </template>
              </el-table-column>-->
              <el-table-column width="220" label="保单号" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">{{scope.row.policy_no}}</span> -->
                  <el-input size="mini" v-model="scope.row.policy_no"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="渠道" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.link_name"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="渠道联系电话" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.link_tel"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="link_tel" label="保单" align="center">
                <template slot-scope="scope">
                  <!-- <span v-if="!scope.row.isEgdit">查看保单</span> -->
                  <el-link
                    type="primary"
                    v-if="scope.row.local_file_path"
                    :href="scope.row.local_file_path"
                    target="_blank"
                  >下载保单</el-link>
                  <el-link
                    type="primary"
                    v-if="scope.row.local_file_path"
                    @click="goBlank(scope.row.local_file_path)"
                  >查看保单</el-link>
                  <el-upload
                    drag
                    v-else
                    class="avatar-uploader"
                    action="#"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="(file, fileList) => {handleChange(file, fileList, scope.$index)}"
                    :multiple="false"
                    :file-list="scope.row.fileList"
                    :limit="1"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <!-- <img
                      v-if="scope.row.local_file_path"
                      :src="scope.row.local_file_path"
                      class="avatar"
                    />-->
                    <!-- <el-link
                        type="primary"
                        v-if="scope.row.local_file_path"
                        :href="scope.row.local_file_path"
                        target="_blank"
                    >{{scope.row.url}}</el-link>-->
                    <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i>  -->
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column width="130px" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="deleteItem(scope.$index,scope.row.id,list)"
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                  <!-- <el-button
                      @click.native.prevent="addItem(scope.$index, list)"
                      type="danger"
                      size="mini"
                      icon="el-icon-plus"
                      circle
                  ></el-button>-->
                  <el-button type="primary" size="mini" @click="save(scope.row)">保存</el-button>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="车牌号" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.plate_number"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="车架号" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.vin"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100px" label="投保人" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.owner_name"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24">
          <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
            <el-form-item>
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="save('addForm')">保存</el-button>
            </el-form-item>
          </el-col>
      </el-row>-->
      <!-- </el-form> -->
    </el-card>
    <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo" />
    <!---->
    <!-- <el-dialog width="60%" title="产品列表" :visible.sync="productVisible" @close="closeProduct">
      <el-form size="mini" :model="searchForm" ref="searchForm" :inline="true">
        <el-form-item label="产品名称" prop="keywords">
          <el-input v-model="searchForm.keywords" palceholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-button type="primary">查询</el-button>
        </el-form-item>
        <div>
          <el-table :data="productList" border size="mini" style="width: 100%;" stripe height="260">
            <el-table-column label="选择" align="center" width="55">
              <template slot-scope="scope">
                <el-radio
                  :label="scope.$index"
                  v-model="pIndex"
                  @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="产品名称"></el-table-column>
          </el-table>
        </div>
        <el-row>
          <el-col
            style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;"
          >
            <el-button size="mini" @click="productVisible = false">取消</el-button>
            <el-button size="mini" type="primary" @click="okProduct">确定</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>-->
    <!---->
  </div>
</template>
<script>
import horizontalScroll from "el-table-horizontal-scroll";
import eCar from "../common/eCar";
import moment from "moment";
import Watermark from "../../utils/waterMark";
export default {
  name: "otherAddInsurance",
  props: ["carVisibleProp"],
  components: {
    eCar,
  },
  directives: {
    horizontalScroll,
  },
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      },
      ownerLoading: false,
      ownerList: [],
      ownerStates: [],

      corp: "",
      corpLoading: "",
      corpList: [],
      corpStates: [],

      pLoading: "",
      pList: [],
      pStates: [],

      isShowCar: false,

      productList: [],
      productVisible: false,
      index: 0,
      pIndex: 0,
      productId: [],
      options: [],
      carList: [],
      loading: false,
      states: [],

      searchForm: {
        keywords: "",
      },
      searchRules: {},
      addForm: {
        vin: "",
        shop_id: "",
        plate_number: "",
        vehicle_type: "",
        car_id: "",
        owner_id: "",
        owner_mobile: "",
        owner_idcard: "",
        owner_name: "",
        toubao_name: "",
        toubao_idcard: "",
        toubao_mobile: "",
        remark: "",
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
      },
      // rules: {
      //   owner_name: [
      //     { required: true, message: "请输入投保人", trigger: "blur" },
      //   ],
      //   toubao_name: [
      //     { required: true, message: "请输入被投保人", trigger: "blur" },
      //   ],
      // },
      title: "保单新增",
      car_number: "",
      fileList: [],
      activeName: "first",
      insurance_date: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      list: [],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
    };
  },
  mounted() {
    // this.carList = this.states.map(item => {
    //   return { value: `${item}`, label: `${item}` };
    // });
    //console.log("111", this.carList);
    this.getCarList(); //车牌号下拉
    this.getProductList();
    this.corpDataList();
    // let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
    // this.$nextTick(() => { //要加载完才能获取$refs
    //   Watermark.set(str,this.$refs.fristhome)
    // })
    this.getList(); //列表项
  },
  methods: {
    goBlank(row) {
      return new Promise((resolve, reject) => {
        let blob = null;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", row);
        xhr.responseType = "blob";
        xhr.onload = () => {
          blob = xhr.response;
          const blobob = new Blob([blob], {
            type: "application/pdf;charset=utf-8",
          });
          const href = window.URL.createObjectURL(blobob);
          window.open(href, "newWindow");
        };
        xhr.onerror = (e) => {
          reject(e);
        };
        xhr.send();
      });
    },
    getCarList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        page: 1,
        pageSize: 9999,
      };
      this.$axios.carFilesList(param).then((res) => {
        if (res.code == 200) {
          this.carList = res.data.data;
        }
      });
    },
    // 列表
    getList() {
      let param = {
        // company_id:sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem("token"),
        page: this.page,
        pageSize: this.limit,
      };
      this.$axios
        .lists(param)
        .then((res) => {
          if (res.code == 200) {
            //console.log(res.data.data, "列表");
            let data = res.data.data;
            this.total = res.data.total
            data.forEach((a) => {
              a.link_name = "";
              a.link_tel = "";
            });
            this.list = data;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.getList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.getList()
    },
    handleAvatarSuccess() {},
    beforeAvatarUpload() {},
    // 新增
    addData() {
      this.$router.push("/insuranceAdd");
    },
    addByProduct() {
      this.$router.push("/insuranceAddByProduct");
    },
    addSysProduct() {
      this.$router.push("/insuranceSysProduct");
    },
    addSysCar() {
      this.$router.push("/insuranceSysCar");
    },
    ownerChange(owner_id) {},
    getCurrentRow(row) {
      if (this.list.length > 0) {
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].product_id == row.id) {
            this.$message.error("保险不能重复添加");
            return;
          }
        }
      }
      this.list[this.index].product_name = row.name;
      this.list[this.index].product_id = row.id;
    },
    getProductList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
      };
      this.$axios
        .insuranceProdcutList(param)
        .then((res) => {
          if (res.code == 200) {
            this.productList = res.data.data;
            this.pList = res.data.data;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    ownerRemoteMethod(query) {
      let _this = this;
      if (query !== "") {
        this.ownerLoading = true;
        let param = {
          queryParams: query,
          operator_id: sessionStorage.getItem("user_id"),
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };

        //console.log('param------',param)

        this.$axios
          .shopList(param)
          .then((res) => {
            if (res.code == 200) {
              this.ownerStates = res.data.data;
            }
          })
          .catch((error) => {
            //console.log(error);
          });
        setTimeout(() => {
          this.ownerLoading = false;
          this.ownerList = this.ownerSet.filter((item) => {
            // 这里的this.list，换为this.ownerSet
            return item.name;
          });
        }, 1000);
      } else {
        this.ownerList = [];
      }
    },
    //保司选择变动时 触发
    getline(rows, index) {
      let ids = [];
      this.corpList.forEach(function (e) {
        ids.push(e.id);
      });
      //console.log('id列表：',ids)

      if (!ids.includes(rows)) {
        this.list[index].corp_id = "";
        this.list[index].corp_name = rows;
      }

      //console.log('触发：',rows)
    },
    corpDataList() {
      let param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        page: 1,
        limit: 1000,
      };
      this.$axios
        .corpList(param)
        .then((res) => {
          if (res.code == 200) {
            this.corpList = res.data.data;
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },

    corpRemoteMethod(query, index) {
      ////console.log('---query---',query,index)
      if (query !== "") {
        this.corpLoading = true;
        let param = {
          queryParams: query,
          //operator_id:sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };
        this.$axios
          .corpList(param)
          .then((res) => {
            if (res.code == 200) {
              this.corpStates = res.data.data;
            }
          })
          .catch((error) => {
            //console.log(error);
          });
        setTimeout(() => {
          this.corpLoading = false;
          this.corpList = this.corpSet.filter((item) => {
            return item.name;
          });
          if (this.corpList.length <= 0) {
            this.list[index].corp_name = query;
          }
        }, 1000);
      } else {
        this.corpList = [];
      }
    },
    pRemoteMethod(query) {
      if (query !== "") {
        this.pLoading = true;
        let param = {
          queryParams: query,
          operator_id: sessionStorage.getItem("user_id"),
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };
        this.$axios
          .insuranceProdcutList(param)
          .then((res) => {
            if (res.code == 200) {
              this.pStates = res.data.data;
            }
          })
          .catch((error) => {
            //console.log(error);
          });
        setTimeout(() => {
          this.pLoading = false;
          this.pList = this.pSet.filter((item) => {
            return item.name;
          });
        }, 1000);
      } else {
        this.pList = [];
      }
    },
    chooseCarInfo(plate_number, ...params) {
      this.addForm.plate_number = plate_number;
      this.addForm.vin = params[3];
      this.addForm.car_id = params[0];
      this.addForm.vehicle_type = params[1];
      this.addForm.toubao_name = params[2];
      this.addForm.shop_id = params[4];

      this.addForm.owner_id = params[4];
      this.addForm.owner_name = params[2];
      this.ownerList = this.ownerStates.map((item) => {
        return { value: item.value, label: item.label };
      });
      this.ownerRemoteMethod(params[2]); //调用远程搜索函数
    },
    handleClick() {},
    closeProduct() {},
    okProduct() {
      this.productVisible = false;
    },
    chooseProduct(index) {
      this.productVisible = true;
      this.index = index;
      ////console.log('list0-------',this.list)
    },
    chooseCar() {
      this.isShowCar = true;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.carList.filter((item) => {
            return item.name.indexOf(query) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    onClose() {
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    },
    handleBeforeUpload() {},
    uploadSuccess() {},
    handleChange(file, fileList, index) {
      let _this = this;

      //------上传到阿里云
      let carFd = new FormData();
      carFd.append("file", file.raw);
      carFd.append("file_type", 1);
      // carFd.append('file_value', this.addForm.vin)
      carFd.append("company_id", sessionStorage.getItem("company_id"));
      carFd.append("access_token", sessionStorage.getItem("token"));
      this.$axios
        .ossUploadFile(carFd)
        .then((res11) => {
          //console.log('aliyun--------',res11)
          if (res11.code == 200) {
            this.$message.success(res11.msg);
            _this.list[index].local_file_path = res11.data.src;
            //console.log('local_file_path--------', _this.list[index].local_file_path)
          } else if (res11.code == 1) {
            this.$message.error(res11.msg);
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
      //------上传到阿里云
    },
    save(item) {
      item.access_token = sessionStorage.getItem("token");
      item.link_name = item.link_name;
      item.link_tel = item.link_tel;
      let tmp=new Date(item.start_time);
      item.effective_date=this.getNextDate(tmp);
      // console.log(item, 1);
      this.$axios.saveGroupByCarNew(item).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getList()
          //this.$router.push("/insuranceTeamOrder");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getNextDate(date){
      var tmp= moment(date.getFullYear()+"-"+(date.getMonth()+1)+'-'+date.getDate()).add(-1, 'd').format('YYYY-MM-DD');
      console.log('tmp:',tmp);
      return  moment(tmp).format('YYYY-MM-DD HH:mm:ss');
    },
    dealSpace(str) {
      return str.replace(/&nbsp;/gi, " ");
    },
    //合计 表格每一列需要带上prop
    getSummaries(param) {
      console.log(param, "444");
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总数量";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "(个)";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    //新增数据
    addItem() {
      // if (!this.addForm.plate_number) {
      //   this.$message.error("请选择车辆，然后新增保险产品");
      //   return false;
      // }
      let item = {
        // product_name: "",
        // product_id: "",
        // price: 0,
        // real_price: 0,
        // sell_price: 0,
        // effective_date: this.getNowTime(),
        // start_time: "",
        // end_time: "",
        // fruitSort: null,
        // firstNum: null,
        // isEgdit: true,
        // product_md_id: "",
        // sy_policy_no: "",
        // corp_id: "",
        // corp_name: "",
        // type: 1,
        // account: 111111,
        // account_number: "11111",
        // local_file_path: "",
        // pay_id: "888",
        // proposal_form: "",
        fileList: [],
        id: null,
        price: "",
        car_id: "",
        corp_id: "",
        end_time: "",
        local_file_path: "",
        policy_no: "",
        product_id: "",
        real_price: "",
        start_time: "",
      };
      this.list.push(item);
    },
    //删除数据
    deleteItem(index, id, list) {
      console.log(index, id, list, 1);
      // list.splice(index, 1);
      if (id) {
        this.del(id);
      }
      this.list.splice(index, 1);
    },
    del(id) {
      let param = {
        access_token: sessionStorage.getItem("token"),
        id: id,
      };
      this.$axios.delIndex(param).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //编辑数据
    edit(index, row) {
      this.$set(row, "isEgdit", true);
    },
    //编辑成功
    editSuccess(index, row) {
      this.$set(row, "isEgdit", false);
    },
    startDateChange(date, idx) {
      // this.list[idx].start_time=date;
      // let tmp1=new Date(date);
      // var tmp= moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('yyyy-MM-DD 23:59:59');
      // this.list[idx].end_time=moment(tmp).subtract(+1, 'days').format('yyyy-MM-DD 23:59:59');

      var tmp1 = new Date(date);
      let tmp = moment(
        tmp1.getFullYear() + "-" + (tmp1.getMonth() + 1) + "-" + tmp1.getDate()
      )
        .add(1, "y")
        .format("yyyy-MM-DD 23:59:59");
      this.list[idx].end_time = moment(tmp)
        .subtract(+1, "days")
        .format("yyyy-MM-DD 23:59:59");
      if (tmp1.getFullYear() % 4 == 0) {
        if (tmp1.getMonth() == 1 && tmp1.getDate() == 29) {
          this.list[idx].end_time = moment(
            tmp1.getFullYear() +
              "-" +
              (tmp1.getMonth() + 1) +
              "-" +
              tmp1.getDate()
          )
            .add(1, "y")
            .format("yyyy-MM-DD 23:59:59");
        }
      }
    },
    //处理默认选中当前日期
    getNowTime(y = 0, m = 0, d = 0) {
      return moment().format("yyyy-MM-DD HH:mm:ss");
      // var now = new Date();
      //
      // var year = now.getFullYear()+y; //得到年份
      // var month = now.getMonth(); //得到月份
      // var date = now.getDate()+d; //得到日期
      // var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      // month = month + 1+m;
      // month = month.toString().padStart(2, "0");
      // date = date.toString().padStart(2, "0");
      // var defaultDate = `${year}-${month}-${date}${hour}`;
      // //console.log(defaultDate)
      // return defaultDate;
      //this.$set(this.addForm, "effective_date", defaultDate);
    },
  },
  computed: {
    ownerSet() {
      return this.ownerStates.map((item) => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },
    corpSet() {
      return this.corpStates.map((item) => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },
    pSet() {
      return this.pStates.map((item) => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },
  },
};
</script>
<style lang="less" scoped>
//https://www.yzktw.com.cn/post/1262748.html

/deep/.el-upload-dragger {
  width: 50px !important;
  height: 50px !important;
}
.upload_group {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .upload_list {
    width: 100px;
    margin-right: 1rem;
  }

  /deep/.el-upload-dragger .el-upload__text {
    font-size: 10px;
    color: #409eff;
  }

  /deep/.el-icon-upload:before {
    width: 30px !important;
    height: 30px !important;
  }
  .upload_list:last-child {
    margin-right: 0;
  }

  /deep/.el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border: 1px solid #999;
  }

  /deep/.el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger .el-icon-upload {
    margin: 10px 0;
  }
}
.table_name:hover {
  color: #409eff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/otherAddInsurance1.vue